import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";

export const ProjectTaskService = {

    getAllTask: async () => {
        try {
            const response = await axios.get(ENDPOINT.ProjectTask);
            return response.data;
        } catch (error) {
            console.error("Error fetching Task:", error.message);
            throw error;
        }
    },

    getAllByProject: async (pro_id) => {
        try {
            const response = await axios.get(`${ENDPOINT.ProjectTask}/project/${pro_id}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching Task:", error.message);
            throw error;
        }
    },

    getDropdownValues: async (field) => {
        try {
            const response = await axios.get(`${ENDPOINT.ProjectTask}/dropdown/${field}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching dropdown values:", error.message);
            throw error;
        }
    },

    getLastTask: async () => {
        try {
            const response = await axios.get(`${ENDPOINT.ProjectTask}/last`);
            return response.data;
        } catch (error) {
            console.error("Error fetching Task:", error.message);
            throw error;
        }
    },


    getTaskById: async (id) => {
        try {
            const response = await axios.get(`${ENDPOINT.ProjectTask}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching Task:", error.message);
            throw error;
        }
    },

    createTask: async (data) => {
        try {
            const response = await axios.post(ENDPOINT.ProjectTask, data, {
                headers: { "Content-Type": "application/json" },
            });
            return response.data;
        } catch (error) {
            console.error("Error creating Task:", error.message);
            throw error;
        }
    },

    updateTask: async (data, id) => {
        try {
            const response = await axios.put(`${ENDPOINT.ProjectTask}/${id}`, data, {
                headers: { "Content-Type": "application/json" },
            });
            return response.data;
        } catch (error) {
            console.error("Error updating Task:", error.message);
            throw error;
        }
    },

    deleteTask: async (id) => {
        try {
            const response = await axios.delete(`${ENDPOINT.ProjectTask}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error deleting Task:", error.message);
            throw error;
        }
    },
};